function buildHashtagHref(boardId: string, hashtag: string): string {
    return `/posts/${encodeURIComponent(boardId)}/search/%23${encodeURIComponent(hashtag)}/page/1`;
}

function linkifyTextNode(documentRef: Document, text: string, boardId: string): DocumentFragment | null {
    const pattern = /#[\p{L}\p{M}\p{N}_-]+/gu;
    const fragment = documentRef.createDocumentFragment();
    let lastIndex = 0;
    let matched = false;

    for (const match of text.matchAll(pattern)) {
        const hashtag = match[0] ?? "";
        const index = match.index ?? -1;
        if (hashtag === "" || index < 0) {
            continue;
        }

        matched = true;

        if (index > lastIndex) {
            fragment.appendChild(documentRef.createTextNode(text.slice(lastIndex, index)));
        }

        const anchor = documentRef.createElement("a");
        anchor.href = buildHashtagHref(boardId, hashtag.slice(1));
        anchor.className = "post-hashtag-link";
        anchor.textContent = hashtag;
        fragment.appendChild(anchor);

        lastIndex = index + hashtag.length;
    }

    if (!matched) {
        return null;
    }

    if (lastIndex < text.length) {
        fragment.appendChild(documentRef.createTextNode(text.slice(lastIndex)));
    }

    return fragment;
}

function isInsideAnchor(node: Node | null): boolean {
    let currentNode = node;

    while (currentNode) {
        if (currentNode instanceof HTMLAnchorElement) {
            return true;
        }

        currentNode = currentNode.parentNode;
    }

    return false;
}

function addHashtagClassToBoardLinks(container: HTMLElement): void {
    const anchors = container.getElementsByTagName("a");

    Array.from(anchors).forEach((anchor) => {
        if (anchor.href.includes("/posts/") && anchor.href.includes("/search/%23")) {
            anchor.classList.add("post-hashtag-link");
        }
    });
}

export function linkifyHashtagsForBoardHtml(html: string, boardId: string): string {
    if (typeof html !== "string" || html === "" || typeof boardId !== "string" || boardId.trim() === "") {
        return html;
    }

    const container = document.createElement("div");
    container.innerHTML = html;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            if (!(node instanceof Text)) {
                return NodeFilter.FILTER_REJECT;
            }

            if (!node.textContent || !node.textContent.includes("#")) {
                return NodeFilter.FILTER_REJECT;
            }

            if (isInsideAnchor(node.parentNode)) {
                return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
        },
    });

    const textNodes: Text[] = [];
    let currentNode = walker.nextNode();
    while (currentNode) {
        if (currentNode instanceof Text) {
            textNodes.push(currentNode);
        }
        currentNode = walker.nextNode();
    }

    textNodes.forEach((node) => {
        const fragment = linkifyTextNode(document, node.textContent ?? "", boardId);
        if (fragment) {
            node.replaceWith(fragment);
        }
    });

    addHashtagClassToBoardLinks(container);

    return container.innerHTML;
}
